import React from "react";
interface InfoCardProps {
  title?: string;
  value?: string;
  unit?: string;
  description?: string;
  loading?: boolean;
  gif?: string;
  timestamp?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, value, unit, description, loading = false, gif, timestamp }) => {
  return (
    <div className="InfoCard">
      <div className="TypeName">{title || "Sem título"}</div>
      <div className="Metrics">
        <div className="MetricImage">
          <img src={gif} alt={title} />
        </div>
        <div className="Stats">
          <div className="Values">
            <div className="StatValue">{value ? value : "---"}&nbsp;</div>
            <div className="StatType">{unit}</div>
          </div>
          <div className="Date">{timestamp}</div>
        </div>
      </div>
      <div className="Info">{description?.replace(/&nbsp;/g, " ") || ""}</div>
    </div>
  );
};

export default InfoCard;
